import React from 'react';
import { Box, Typography, Chip, Alert } from '@mui/material';
import { Group as GroupIcon } from '@mui/icons-material';
import ShareDialog from './ShareDialog';
import { shareReportSubscription, getReportSubscriptionShares } from '../../services/report-subscription-sharing.service';
import _ from 'lodash';

const ShareReportSubscriptionDialog = ({ 
    reportSubscription, 
    onClose, 
    onShareSuccess 
}) => {
    const handleShare = async (reportSubscriptionId, selectedUsers, message, isUniversal, activeFacility) => {
        return await shareReportSubscription(reportSubscriptionId, selectedUsers, message, isUniversal, activeFacility);
    };

    const handleLoadShares = async (reportSubscriptionId) => {
        return await getReportSubscriptionShares(reportSubscriptionId);
    };

    const renderItemInfo = (item, existingShares) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <GroupIcon sx={{ color: '#2196f3' }} />
                <Typography variant="body1" sx={{ color: '#333333', fontSize: '0.9rem' }}>
                    Share "{item?.name || 'this report subscription'}" with team members
                </Typography>
            </Box>

            <Alert severity="info" sx={{ mb: 1 }}>
                Share your report subscription with other users. Recipients will receive a notification and can choose to accept or decline.
                {existingShares.length > 0 && (
                    <Box mt={1}>
                        <strong>Current shares:</strong> {existingShares.length} user(s) already have access to this report.
                    </Box>
                )}
            </Alert>

            <Box sx={{ p: 2, background: '#f8f9fa', borderRadius: 1, border: '1px solid rgba(0,0,0,0.1)' }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    <strong>Report Name:</strong> {item?.name || 'N/A'}
                </Typography>

                <Typography variant="body2" color="text.secondary" gutterBottom>
                    <strong>Page:</strong> {_.capitalize(item?.page) || 'N/A'}
                </Typography>

                <Box display="flex" gap={1} mt={1} flexWrap="wrap">
                    {item?.interval && (
                        <Chip 
                            label={_.capitalize(item.interval)} 
                            size="small" 
                            sx={{
                                background: 'rgba(33, 150, 243, 0.1)',
                                color: '#2196f3',
                                border: '1px solid rgba(33, 150, 243, 0.3)',
                                height: '24px',
                                fontSize: '0.75rem'
                            }}
                        />
                    )}
                    {item?.title && (
                        <Chip 
                            label={item.title} 
                            size="small" 
                            sx={{
                                background: 'rgba(156, 39, 176, 0.1)',
                                color: '#9c27b0',
                                border: '1px solid rgba(156, 39, 176, 0.3)',
                                height: '24px',
                                fontSize: '0.75rem'
                            }}
                        />
                    )}
                    {item?.isActive !== undefined && (
                        <Chip 
                            label={item.isActive ? 'Active' : 'Inactive'} 
                            size="small" 
                            sx={{
                                background: item.isActive ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)',
                                color: item.isActive ? '#4caf50' : '#f44336',
                                border: `1px solid ${item.isActive ? 'rgba(76, 175, 80, 0.3)' : 'rgba(244, 67, 54, 0.3)'}`,
                                height: '24px',
                                fontSize: '0.75rem'
                            }}
                        />
                    )}
                </Box>
            </Box>
        </Box>
    );

    return (
        <ShareDialog
            open={true}
            onClose={onClose}
            title="Share Report Subscription"
            item={reportSubscription}
            itemType="REPORT"
            onShare={handleShare}
            onLoadShares={handleLoadShares}
            renderItemInfo={renderItemInfo}
            shareButtonText="Share Report" 
            allowUniversal={false} // Reports don't support universal access yet
        />
    );
};

export default ShareReportSubscriptionDialog; 